import {Controller} from "stimulus";

export default class BackLinkController extends Controller {
    connect() {
        this.element.setAttribute('href', document.referrer);
    }
}
